import { _fakeMessage, BaseMessage, RawBaseMassage } from './Communication';
import { findAllFiles, readBinaryFile, writeFile } from './Filesystem/Helper';
import { DirectoryWriter } from './Filesystem/Container';

// Submodules
import { getUUID } from '../utils/Helper';

import utils = egr.wcf.utils;

interface SynchronizeWebaction extends BaseMessage {
    type: 'webaction';
    action: 'synchronize';
    arguments: 'background' | 'foreground';
}

export function synchronizeWebAction(value: 'background' | 'foreground'): void {
    _fakeMessage({
        transaction_id: -1,
        type: 'webaction',
        action: 'synchronize',
        arguments: value
    } as SynchronizeWebaction & RawBaseMassage);
}

export async function zipDirectory(path: string): Promise<ArrayBuffer> {
    const l: number = path.length;
    const zip: JSZip = new JSZip();

    for await (const file of findAllFiles(path)) {
        const content: ArrayBuffer = await readBinaryFile(file);
        zip.file(file.substr(l), content);
    }

    return zip.generateAsync({type: 'arraybuffer'});
}

export async function unzip(content: ArrayBuffer, path: string): Promise<void> {
    const zip: JSZip = new JSZip();
    await zip.loadAsync(content);

    const container: DirectoryWriter = new DirectoryWriter(path);
    const lock: utils.async.Lock = new utils.async.Lock();
    const unzipFile: (zipPath: string, file: JSZipObject) => Promise<void> = async (zipPath: string, file: JSZipObject): Promise<void> => {
        const lockContext: utils.async.LockContext = await lock.acquireLock();
        try {
            const fileContent: ArrayBuffer = await file.async('arraybuffer');
            await container.addFile(fileContent, zipPath);
        } finally {
            lockContext.unlock();
        }
    };

    const promises: Array<Promise<void>> = [];
    zip.forEach((relPath: string, file: JSZipObject): void => {
        if (!relPath.endsWith('/')) {
            promises.push(unzipFile(relPath, file));
        }
    });

    await Promise.all(promises);
}

export function openFile(): void {
    const input: HTMLInputElement = document.createElement('input');
    input.type = 'file';
    input.accept = '.pec,.pbox,.obk';
    input.onchange = async (): Promise<void> => {
        let importPath: string;
        const fileList: FileList | null = input.files;
        if (fileList == null || fileList.length < 1) {
            return;
        }

        // tslint:disable-next-line:egr-no-numeric-literal-after-slice
        const extension: string  = fileList[0].name.split('.').slice(-1)[0].toLocaleLowerCase();
        if (extension === 'pbox') {
            importPath = '/imports/' + getUUID() + '/';
            const promises: Array<Promise<void>> = [];
            let zip: JSZip = new JSZip();
            zip = await zip.loadAsync(fileList[0]);
            zip.forEach((path: string, file: JSZipObject): void => {
                promises.push((async (): Promise<void> => {
                    return writeFile(
                        importPath + path,
                        await file.async('arraybuffer')
                    );
                })());
            });

            await Promise.all<void>(promises);
        } else {
            importPath = '/imports/' + getUUID() + '.' + extension;
            await writeFile(
                importPath,
                await utils.arraybuffer.fromBlob(fileList[0])
            );
        }

        const fileExtension: string | undefined = fileList[0].name.split('.').pop();
        if (utils.string.isNullOrEmpty(fileExtension)) {
            return;
        }
        // ToDo: use  new app api module
        _fakeMessage({
            transaction_id: -1,
            type: 'webaction',
            action: 'openfile',
            arguments: {
                type: fileExtension.toLocaleLowerCase(),
                path: importPath
            }
        });
    };
    input.click();
}


// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/submodules/app-api/DebugActions.ts